import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  loading: false,
  saving: false,
};

export default function tag(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@tags/INDEX_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.list = [];
      });

    case '@tags/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@tags/INDEX_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
      });

    case '@tags/CREATE_REQUEST':
    case '@tags/UPDATE_REQUEST':
    case '@tags/DELETE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
      });

    case '@tags/CREATE_SUCCESS':
    case '@tags/CREATE_FAILURE':
    case '@tags/SAVE_FINISH':
      return produce(state, draft => {
        draft.saving = false;
      });

    default:
      return state;
  }
}
